import React from 'react';
import JobTile from './JobTile';

const { __, getLocaleData } = window.wp.i18n;

class JobList extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      data: this.props.jobs
    };
  }

  componentDidUpdate (prevProps) {
    if (prevProps.jobs !== this.props.jobs) {
      this.setState({ data: this.props.jobs });
    }
  }

  onSort (_event, sortKey, type) {
    const data = this.props.jobs;
    if (type === 'down') {
      data.sort((a, b) => a[sortKey] && b[sortKey] ? b[sortKey].localeCompare(a[sortKey]) : -1);
    } else {
      data.sort((a, b) => b[sortKey] && a[sortKey] ? a[sortKey].localeCompare(b[sortKey]) : -1);
    }
    this.setState({ data });
  }

  render () {
    return (
      <section className="table filters-content">
        <div className="table-header">
          <div className="table-td" style={{ display: (this.props.filtercolumnselections).includes('job_name') == true ? '' : 'none' }}>
            <div className="table-td-flex">
              <span>{ __('Job name', 'macs-react-jobs') }</span>
              <div className="table-sort">
                <button className="table-sort-top" onClick={e => this.onSort(e, 'title', 'up')} aria-label={ __('sort top jobName', 'macs-react-jobs') }></button>
                <button className="table-sort-bottom" onClick={e => this.onSort(e, 'title', 'down')} aria-label={ __('sort bottom jobName', 'macs-react-jobs') }></button>
              </div>
            </div>
          </div>

          <div className="table-td" style={{ display: (this.props.filtercolumnselections).includes('country') == true ? '' : 'none' }}>
           <div className="table-td-flex">
             <span>{ __('Country', 'macs-react-jobs') }</span>
             <div className="table-sort">
               <button className="table-sort-top" onClick={e => this.onSort(e, 'country', 'up')} aria-label={ __('sort top country of the jobs', 'macs-react-jobs') }></button>
               <button className="table-sort-bottom" onClick={e => this.onSort(e, 'country', 'down')} aria-label={ __('sort bottom country of the jobs', 'macs-react-jobs') }></button>
             </div>
           </div>
         </div>

          <div className="table-td" style={{ display: (this.props.filtercolumnselections).includes('location') == true ? '' : 'none' }}>
           <div className="table-td-flex">
             <span>{ __('Location', 'macs-react-jobs') }</span>
             <div className="table-sort">
               <button className="table-sort-top" onClick={e => this.onSort(e, 'location', 'up')} aria-label={ __('sort top location of the jobs', 'macs-react-jobs') }></button>
               <button className="table-sort-bottom" onClick={e => this.onSort(e, 'location', 'down')} aria-label={ __('sort bottom location of the jobs', 'macs-react-jobs') }></button>
             </div>
           </div>
         </div>

         <div className="table-td" style={{ display: (this.props.filtercolumnselections).includes('experience_level') == true ? '' : 'none' }}>
          <div className="table-td-flex">
            <span>{ __('Experience level', 'macs-react-jobs') }</span>
            <div className="table-sort">
              <button className="table-sort-top" onClick={e => this.onSort(e, 'experience_level', 'up')} aria-label={ __('sort top experienceLevel of the jobs', 'macs-react-jobs') }></button>
              <button className="table-sort-bottom" onClick={e => this.onSort(e, 'experience_level', 'down')} aria-label={ __('sort bottom experience Level of the jobs', 'macs-react-jobs') }></button>
            </div>
          </div>
        </div>

           <div className="table-td" style={{ display: (this.props.filtercolumnselections).includes('department') == true ? '' : 'none' }}>
            <div className="table-td-flex">
              <span>{ __('Department', 'macs-react-jobs') }</span>
              <div className="table-sort">
                <button className="table-sort-top" onClick={e => this.onSort(e, 'department', 'up')} aria-label={ __('sort top department of the jobs', 'macs-react-jobs') }></button>
                <button className="table-sort-bottom" onClick={e => this.onSort(e, 'department', 'down')} aria-label={ __('sort bottom department of the jobs', 'macs-react-jobs') }></button>
              </div>
            </div>
          </div>

          <div className="table-td" style={{ display: (this.props.filtercolumnselections).includes('contract_type') == true ? '' : 'none' }}>
           <div className="table-td-flex">
             <span>{ __('Contract Type', 'macs-react-jobs') }</span>
             <div className="table-sort">
               <button className="table-sort-top" onClick={e => this.onSort(e, 'contract_type', 'up')} aria-label={ __('sort top contractType of the jobs', 'macs-react-jobs') }></button>
               <button className="table-sort-bottom" onClick={e => this.onSort(e, 'contract_type', 'down')} aria-label={ __('sort bottom contractType of the jobs', 'macs-react-jobs') }></button>
             </div>
           </div>
         </div>

         <div className="table-td" style={{ display: (this.props.filtercolumnselections).includes('business_units') == true ? '' : 'none' }}>
          <div className="table-td-flex">
            <span>{ __('Business Unit', 'macs-react-jobs') }</span>
            <div className="table-sort">
              <button className="table-sort-top" onClick={e => this.onSort(e, 'sbu', 'up')} aria-label={ __('sort top businessUnits of the jobs', 'macs-react-jobs') }></button>
              <button className="table-sort-bottom" onClick={e => this.onSort(e, 'sbu', 'down')} aria-label={ __('sort bottom businessUnits of the jobs', 'macs-react-jobs') }></button>
            </div>
          </div>
        </div>
        <div className="table-td" style={{ display: (this.props.filtercolumnselections).includes('professional_communities') == true ? '' : 'none' }}>
          <div className="table-td-flex">
            <span>{ __('Professional communities', 'macs-react-jobs') }</span>
            <div className="table-sort">
              <button className="table-sort-top" onClick={e => this.onSort(e, 'professional_communities', 'up')} aria-label={ __('sort top professional communities of the jobs', 'macs-react-jobs') }></button>
              <button className="table-sort-bottom" onClick={e => this.onSort(e, 'professional_communities', 'down')} aria-label={ __('sort bottom professional communities of the jobs', 'macs-react-jobs') }></button>
            </div>
          </div>
        </div>
        <div className="table-td" style={{ display: (this.props.filtercolumnselections).includes('brand') == true ? '' : 'none' }}>
          <div className="table-td-flex">
            <span>{ __('Brand', 'macs-react-jobs') }</span>
            <div className="table-sort">
              <button className="table-sort-top" onClick={e => this.onSort(e, 'brand', 'up')} aria-label={ __('sort top brand of the jobs', 'macs-react-jobs') }></button>
              <button className="table-sort-bottom" onClick={e => this.onSort(e, 'brand', 'down')} aria-label={ __('sort bottom brand of the jobs', 'macs-react-jobs') }></button>
            </div>
          </div>
        </div>
        {/* }
           <div className="table-td">
            <div className="table-td-flex">
              <span>{ __( 'Posted on', 'macs-react-jobs' ) }</span>
              <div className="table-sort">
                <button className="table-sort-top" aria-label="sort-top-button-jobsPostedOn"></button>
                <button className="table-sort-bottom" aria-label="sort-bottom-button-jobsPostedOn"></button>
              </div>
            </div>
          </div>
        */}

          {/* <div className="table-td"></div> */}

        </div>
        { this.state.data.map(job => <JobTile key={job.href} data={job} filtercolumnselections = {this.props.filtercolumnselections} />) }
      </section>
    );
  }
}

export default JobList;
